<template>
  <div
    v-if="showInstallBanner && !shouldHideBannerByRoute"
    class="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-4 z-[99999] shadow-lg pb-safe"
    style="z-index: 2147483002 !important;"
  >
    <div class="flex items-center justify-between">
      <div class="flex items-center space-x-3">
        <div>
          <h3 class="text-sm font-medium text-gray-900">
            {{ $t('common.pwa.install.title') }}
          </h3>
          <p class="text-xs text-gray-500">
            {{ $t('common.pwa.install.description') }}
          </p>
        </div>
      </div>
      <div class="flex space-x-2">
        <button
          @click="dismissBanner"
          class="text-gray-400 hover:text-gray-600"
        >
          <Icon icon-name="IconX" />
        </button>
        <button
          @click="installPWA"
          class="bg-primary-500 text-white px-4 py-2 rounded-lg text-sm font-medium hover:bg-primary-600"
        >
          {{ $t('common.pwa.install.button') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { useMobileStore } from "@/stores/mobile"
import { mapStores } from "pinia"
import Icon from "@/components/Icon.vue"

export default defineComponent({
  name: "PWAInstallBanner",
  components: { Icon },
  data() {
    return {
      showInstallBanner: false,
      deferredPrompt: null as any,
    }
  },
  computed: {
    ...mapStores(useMobileStore),
    shouldHideBannerByRoute(): boolean {
      return Boolean(this.$route.meta?.hidePwaInstallBanner)
    },
  },
  watch: {
    $route() {
      this.syncBannerVisibilityWithContext()
    },
    "mobileStore.isMobileSize"() {
      this.syncBannerVisibilityWithContext()
    },
  },
  mounted() {
    // Vérifier si l'utilisateur a déjà fermé le bandeau
    const bannerDismissed = localStorage.getItem('pwa-banner-dismissed')
    if (!bannerDismissed) {
      this.initPWAInstall()
    }
  },
  methods: {
    initPWAInstall() {
      // Écouter l'événement beforeinstallprompt
      window.addEventListener('beforeinstallprompt', (e) => {
        // Empêcher l'affichage automatique du prompt
        e.preventDefault()
        
        // Stocker l'événement pour l'utiliser plus tard
        this.deferredPrompt = e
        
        // Afficher notre bandeau personnalisé seulement sur mobile
        this.syncBannerVisibilityWithContext()
      })

      // Écouter l'événement appinstalled pour masquer le bandeau
      window.addEventListener('appinstalled', () => {
        this.showInstallBanner = false
        this.deferredPrompt = null
      })
    },

    syncBannerVisibilityWithContext() {
      if (this.shouldHideBannerByRoute) {
        this.showInstallBanner = false
        return
      }

      this.showInstallBanner = !!this.deferredPrompt && this.mobileStore.isMobileSize
    },
    
    async installPWA() {
      if (!this.deferredPrompt) {
        return
      }

      // Afficher le prompt d'installation
      this.deferredPrompt.prompt()

      // Attendre la réponse de l'utilisateur
      const { outcome } = await this.deferredPrompt.userChoice

      // Réinitialiser
      this.deferredPrompt = null
      this.showInstallBanner = false
    },

    dismissBanner() {
      this.showInstallBanner = false
      // Optionnel : sauvegarder dans localStorage pour ne plus l'afficher
      localStorage.setItem('pwa-banner-dismissed', 'true')
    }
  }
})
</script> 